import { Navigate, Route, Routes } from 'react-router-dom'
import { ToastProvider } from 'components/common/Toast'
import { RequireSession } from 'auth/RequireSession'
import TopBar from 'components/layout/TopBar'
import CallEntityLookup from 'pages/CallEntityLookup'
import EntityEdit from 'pages/EntityEdit'
import EntityView from 'pages/EntityView'
import Home from 'pages/Home'
import Landing from 'pages/Landing'
import Login from 'pages/Login'
import SSOCallback from 'pages/SSOCallback'

export default function App() {
  return (
    <ToastProvider>
      <Routes>
        {/* SSO entry points — outside the session guard. */}
        <Route path="/callback" element={<SSOCallback />} />
        <Route path="/login" element={<Login />} />

        {/* A session with no record lands on a plain notice. The developer test page
            (every link shape) lives at /testing and is linked from nowhere. */}
        <Route path="/" element={<RequireSession><><TopBar /><Landing /></></RequireSession>} />
        <Route path="/testing" element={<RequireSession><><TopBar /><Home /></></RequireSession>} />
        {/* Mirrors EntityViewDetails.aspx?entityType=…&entityID=… or ?q=… */}
        <Route path="/view" element={<RequireSession><><TopBar /><EntityView /></></RequireSession>} />
        {/* From a phone call: finds the caller's lead/enquiry by country code + mobile, then opens it. */}
        <Route path="/view/call" element={<RequireSession><><TopBar /><CallEntityLookup /></></RequireSession>} />
        <Route path="/view/:entityType/:entityId" element={<RequireSession><><TopBar /><EntityView /></></RequireSession>} />
        <Route path="/EntityViewDetails.aspx" element={<RequireSession><><TopBar /><EntityView /></></RequireSession>} />
        <Route path="/UserCRMCampaign/EntityViewDetails.aspx" element={<RequireSession><><TopBar /><EntityView /></></RequireSession>} />

        <Route path="/edit" element={<RequireSession><><TopBar /><EntityEdit /></></RequireSession>} />
        <Route path="/edit/:entityType/:entityId" element={<RequireSession><><TopBar /><EntityEdit /></></RequireSession>} />
        <Route path="/EntityEdit.aspx" element={<RequireSession><><TopBar /><EntityEdit /></></RequireSession>} />
        <Route path="/UserCRMCampaign/EntityEdit.aspx" element={<RequireSession><><TopBar /><EntityEdit /></></RequireSession>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ToastProvider>
  )
}
